"use strict";

var isValue = require("../is-value");

var keys = Object.keys;

module.exports = function (object) { return keys(isValue(object) ? Object(object) : object); };



//////////////////
// WEBPACK FOOTER
// /Users/Fuunnx/workspace/zygmund/~/es5-ext/object/keys/shim.js
// module id = ../../../node_modules/es5-ext/object/keys/shim.js
// module chunks = 1